"use client"

import Link from "next/link"
import { usePathname } from "next/navigation"
import { Button } from "@/components/ui/button"
import { Separator } from "@/components/ui/separator"
import { ModeToggle } from "@/components/theme-toggle"
import { FooterEntry, SiteConfig } from "@/lib/siteConfig"

export function Footer() {
  const pathname = usePathname()
  const footerEntries = Object.values(SiteConfig.footer);

  const isActive = (uri: string) => (pathname === uri) ? "text-sky-500 dark:text-sky-200" : ""

  return (
    <footer className="mt-16 border-t">
      <div className="mx-auto max-w-6xl px-6 py-10">
        <div className="flex flex-col gap-6 md:flex-row md:items-center md:justify-between">
          <div>
            <h2 className="text-lg font-semibold text-sky-500 dark:text-sky-200">{SiteConfig.metadata.domain}</h2>
            <p className="text-sm text-muted-foreground">
              Simple Project for Learning.
            </p>
          </div>

          <div className="flex flex-wrap gap-3">
            <Button
              className={`hover:bg-slate-200 hover:dark:bg-gray-900 ${isActive("/")}`}
              variant="ghost"
              asChild
            >
              <Link prefetch={false} href="/">Home</Link>
            </Button>

            {footerEntries.map((footerEntry: FooterEntry) => (
              <Button
                className={`hover:bg-slate-200 hover:dark:bg-gray-900 ${isActive(footerEntry.uri)}`}
                key={footerEntry.name} 
                variant="ghost" 
                asChild
              >
                <Link prefetch={false} href={footerEntry.uri}>{footerEntry.name}</Link>
              </Button>
            ))}
          </div>
        </div>

        <Separator className="my-6" />

        <div className="flex flex-col gap-2 text-sm text-muted-foreground md:flex-row md:justify-between">
          <p>© {new Date().getFullYear()} {SiteConfig.metadata.domain}. All rights reserved.</p>
          <ModeToggle /> 
          <div className="flex gap-4">
            {footerEntries.map((footerEntry: FooterEntry) => (
              <Link prefetch={false} key={footerEntry.name} href={footerEntry.uri} className="hover:underline">
                {footerEntry.name}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  )
}